<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="파트너 의뢰 조회"
      desc="전체 파트너 의회 내역을 확인할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="900"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="estimate_content" slot-scope="props" style="width: 120px; margin: auto;">
        <div @click.stop.prevent="clickEst(props.item)" style="cursor: pointer">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="request_partner_detail" slot-scope="props" style="width: 120px; margin: auto;">
        <div @click.stop.prevent="clickRequestDetail(props.item)" style="cursor: pointer">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button is-danger" @click.stop.prevent="clickProd(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'RequestPartner',
    mixins: [
      ListMixin
    ],

    computed: {
      partnerName(){
        if(this.partners.length>0){
          for(let i=0; i<this.partners.length; i++){
            if(this.partners[i].value===this.requestItem.partner_id){
              return this.partners[i].name;
              break;
            }
          }
        }
      }
    },

    data () {
      return {
        selectedItem: undefined,    // 팝업으로 표시할 선택된 아이템
        requestItem:undefined,
        partners: [],
        modalItem: 0
      }
    },

    created () {
      this.init();
    },

    methods: {
      init() {
        this.initializing('request_partner', 'estimate/partner');
      },
      getDataFromServer() {
        this.getData();
      },
      // 견적요청서 보기
      clickEst(item) {
        this.$axios.get(this.getUrl('estimate/request/'+item.request_id)).then(res=>{
          if(res.status===200){
            this.selectedItem = {
              name: res.data.name,
              email: res.data.email,
              created_time: res.data.created_time,
              phone: res.data.phone,
              steps: res.data.steps
            }

            let value = {
              selectedItem: this.selectedItem
            }
            this.$store.commit('openModal', {type:'modal-order-content', value:value});
          }
        })
      },

      // 의뢰 상세 보기
      clickRequestDetail(item){
        this.$axios.get(this.getUrl('estimate/partner/'+item.id)).then(res=>{
          if(res.status===200){
            this.requestItem = res.data;

            let value = {
              requestItem: this.requestItem
            }
            this.$store.commit('openModal', {type:'modal-request-partner-detail', value: value});
          }
        })
      },

      //견적서 보기
      clickBid(item, bid) {
        this.selectedItem = {
          bid_info: item.bid_info,
          request_id: item.id,
          price: bid.price,
          note: bid.note,
          price_info: bid.price_info,
          user: bid.user,
          created_time: bid.created_time
        };
        setTimeout(res => {
          this.$refs.bidModal.open();
        }, 100);
      },

      clickProd(item, kind) {
        if(kind === 'delete') {
          let value = {
            id: item.id,
            url: 'estimate/partner/',
            title: '의뢰를 삭제하시겠습니까?'
          };
          this.$store.commit('openModal', {type:'modal-delete', value: value, width: '500px'})
        }
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .bid-state-done
    background-color #d5514b
  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0

  .modal-step
    padding 4px
    margin-top 12px

</style>
